/**
 * Prevents MUI Dialog from closing when the user clicks outside the dialog paper.
 * Menus, Selects, Popovers, and other non-Dialog Modals are unaffected.
 */
export function installDisableDialogBackdropClose(): void {
  const shouldBlock = (target: EventTarget | null): boolean => {
    if (!(target instanceof Element)) return false;
    if (!target.closest(".MuiDialog-root")) return false;
    return (
      target.classList.contains("MuiDialog-container") ||
      target.classList.contains("MuiBackdrop-root")
    );
  };

  const handler = (event: Event) => {
    if (shouldBlock(event.target)) {
      event.stopPropagation();
    }
  };

  document.addEventListener("mousedown", handler, true);
  document.addEventListener("click", handler, true);
}
